<script lang="ts" setup>
import { useErrorStore } from '@/stores/errorStore'

const errorStore = useErrorStore()
const errors = computed(() => errorStore.errors)

const dismissError = (id: string) => {
  errorStore.removeError(id)
}

const calculateMargin = (index: number) => {
  const margin = index === 0 ? 10 : index * 50 + 10
  return margin + 'px'
}
</script>

<template>
  <VSnackbar
    v-for="(error, index) in errors"
    :key="error.id"
    :model-value="true"
    timeout="5000"
    color="error"
    location="top center"
    variant="tonal"
    :style="{ 'margin-block-start': calculateMargin(index) }"
    @update:model-value="dismissError(error.id)"
  >
    <template #text>
      {{ error.message }}
    </template>
    <template #actions>
      <VBtn icon="bi-x-circle" color="error" @click="dismissError(error.id)" />
    </template>
  </VSnackbar>
</template>
